import { render, staticRenderFns } from "./AddNewLogoDialog.vue?vue&type=template&id=7f5ee630&"
import script from "./AddNewLogoDialog.vue?vue&type=script&lang=js&"
export * from "./AddNewLogoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports